module.exports = __webpack_public_path__ + "img/shopify-four-en.39b5b786.png";